import { c as _c } from "react/compiler-runtime";
import useCartReservationInProgress from '@/contexts/cartContext/hooks/useCartReservationInProgress';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { FTunnelPageBookingTypeEnum, FTunnelPageStepEnum } from '@/types/tunnel';
import { LoaderWithContainer } from '@winelidays/wld-tsx-2/elements';
import useTunnelActiveStep from '../../context/hooks/useTunnelActiveStep';
import useTunnelBookingType from '../../context/hooks/useTunnelBookingType';
import TunnelStepper from './Stepper';
const TunnelTemplate = t0 => {
    const $ = _c(27);
    const { children, className: t1, stickyContent, bottomContent, loading } = t0;
    const incomingClassName = t1 === undefined ? "" : t1;
    const translate = useTranslate();
    const activeStep = useTunnelActiveStep();
    const bookingType = useTunnelBookingType();
    const reservationInProgress = useCartReservationInProgress();
    const isEdition = !!reservationInProgress;
    let t2;
    if ($[0] !== stickyContent) {
        t2 = stickyContent ? <div className="w-full h-fit z-10 mb-6 lg:flex-shrink-0 lg:w-[40%] lg:max-w-[394px] lg:mt-8 lg:mb-8 lg:mr-8 lg:rounded lg:shadow-modal">{stickyContent}</div> : null;
        $[0] = stickyContent;
        $[1] = t2;
    }
    else {
        t2 = $[1];
    }
    const sideSticky = t2;
    let t3;
    if ($[2] !== children || $[3] !== loading) {
        t3 = loading ? <LoaderWithContainer className="h-72"/> : children;
        $[2] = children;
        $[3] = loading;
        $[4] = t3;
    }
    else {
        t3 = $[4];
    }
    const computedChildren = t3;
    const className = `w-full flex flex-col items-center lg:my-12 !my-0 ${incomingClassName}`;
    let t4;
    if ($[5] !== activeStep || $[6] !== bookingType || $[7] !== isEdition || $[8] !== translate) {
        t4 = activeStep === FTunnelPageStepEnum.booking ? translate(`tunnel_page.${bookingType === FTunnelPageBookingTypeEnum.voucher ? "voucher-" : ""}booking${isEdition ? ".edition" : ""}.title`) : translate("validation_page.contact.title");
        $[5] = activeStep;
        $[6] = bookingType;
        $[7] = isEdition;
        $[8] = translate;
        $[9] = t4;
    }
    else {
        t4 = $[9];
    }
    const title = t4;
    let t5;
    if ($[10] !== title || $[11] !== translate) {
        t5 = FTunnelPageStepEnum.booking ? title : translate("validation_page.contact.nav_label");
        $[10] = title;
        $[11] = translate;
        $[12] = t5;
    }
    else {
        t5 = $[12];
    }
    const navLabel = t5;
    let t6;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = <TunnelStepper />;
        $[13] = t6;
    }
    else {
        t6 = $[13];
    }
    let t7;
    if ($[14] !== title) {
        t7 = <h2 className="text-2xl font-bold mb-4">{title}</h2>;
        $[14] = title;
        $[15] = t7;
    }
    else {
        t7 = $[15];
    }
    let t8;
    if ($[16] !== computedChildren || $[17] !== t7) {
        t8 = <div className="tunnel-padding-x pt-8 pb-8 w-full lg:rounded-bl lg:flex-grow">{t7}{computedChildren}</div>;
        $[16] = computedChildren;
        $[17] = t7;
        $[18] = t8;
    }
    else {
        t8 = $[18];
    }
    let t9;
    if ($[19] !== sideSticky || $[20] !== t8) {
        t9 = <div className="w-full flex flex-col rounded-b rounded-t px-px lg:mb-8 lg:last:mb-0">{t6}<div className="relative w-full flex flex-col lg:rounded-b lg:flex-row">{t8}{sideSticky}</div></div>;
        $[19] = sideSticky;
        $[20] = t8;
        $[21] = t9;
    }
    else {
        t9 = $[21];
    }
    let t10;
    if ($[22] !== bottomContent || $[23] !== className || $[24] !== navLabel || $[25] !== t9) {
        t10 = <section className={className} id="tunnel-main" data-nav-label={navLabel}>{t9}{bottomContent}</section>;
        $[22] = bottomContent;
        $[23] = className;
        $[24] = navLabel;
        $[25] = t9;
        $[26] = t10;
    }
    else {
        t10 = $[26];
    }
    return t10;
};
export default TunnelTemplate;
